import "@/App.css";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import BeforeAfterSection from "@/components/BeforeAfterSection";
import ContactSection from "@/components/ContactSection";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <BeforeAfterSection />
      <ContactSection />
    </div>
  );
}

export default App;
